import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  kbCategoryList: [],
  kbArticleList: [],
  kbDepList: [],
  kbCatNameList: [],
  isLoading: true,
  isDetailLoading: true,
};

const kbSlice = createSlice({
  name: 'knowledgebase',
  initialState,
  reducers: {
    setKbCategoryList(state, actions) {
      state.kbCategoryList = actions.payload;
      state.isLoading = false;
    },
    setKbDepList(state, actions) {
      state.kbDepList = actions.payload;
      state.isLoading = false;
    },
    setKbArticleList(state, actions) {
      state.kbArticleList = actions.payload;
      state.isLoading = false;
    },
    setKbCatNameList(state, actions) {
      state.kbCatNameList = actions.payload;
      state.isLoading = false;
    },
    getKbDetail(state, actions) {
      state.kbDetail = actions.payload;
      state.isDetailLoading = false;
    },
  },
});

export const { setKbCategoryList, getKbDetail, setKbDepList, setKbArticleList, setKbCatNameList } = kbSlice.actions;

const kbReducer = kbSlice.reducer;
export default kbReducer;
